import React from "react";
import Legel_Entity_table from "./legel_Entity_table/Legel_Entity_table";
import Legal_Entity_Form from "./legal_Entity_Form/Legal_Entity_Form";
import Common_Back_Btn from "../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import { FixIDS } from "../../../../../../utils/fixIDS";
import { useSelector } from "react-redux";

function Legel_Entity() {

  const permissions = useSelector((state) => state.auth.permissions);
  
  const haveReadPermission = permissions?.includes(FixIDS.legel_entity.List);
  const haveAddPermission = permissions?.includes(FixIDS.legel_entity.Add);
  

  return (
    <>
      <section className="Imperiality">
        <div className="back_div">
          <Common_Back_Btn backText="Legel Entity" />
        </div>

        <div className="imperiality_Form_div">
          { haveAddPermission && <Legal_Entity_Form />}
        </div>

        <div className="imperiality_table_div">
          { haveReadPermission && <Legel_Entity_table />}
        </div>
      </section>
    </>
  );
}

export default Legel_Entity;
